(function () {
  'use strict';

  const STORAGE_KEY = 'vip_access_granted';
  const PRICE_LIST_SELECTOR =
    'price-list[data-bf-early-access="true"]';
  const TEMPLATE_SELECTOR =
    'template[data-bf-early-access-template]';

  function hasEarlyAccess() {
    try {
      const savedAccess = localStorage.getItem(STORAGE_KEY);

      if (!savedAccess) return false;

      const access = JSON.parse(savedAccess);

      return (
        access &&
        access.granted === true &&
        typeof access.expiresAt === 'number' &&
        access.expiresAt > Date.now()
      );
    } catch (error) {
      console.warn('VIP access validation failed:', error);
      return false;
    }
  }

  function applyEarlyAccess(priceList) {
    if (!hasEarlyAccess()) return;

    if (
      !priceList ||
      priceList.dataset.bgEarlyAccessApplied === 'true'
    ) {
      return;
    }

    const template = priceList.querySelector(
      ':scope > ' + TEMPLATE_SELECTOR
    );

    if (!template) return;

    // Hide existing Shopify prices and discounts.
    priceList.querySelectorAll(
      ':scope > sale-price, ' +
      ':scope > compare-at-price, ' +
      ':scope > discount, ' +
      ':scope > .save-badge'
    ).forEach(function (element) {
      element.classList.add('bf-early-access-original-hidden');
    });

    // Insert the metafield prices.
    const content = template.content.cloneNode(true);
    const unitPrice = priceList.querySelector(':scope > unit-price');

    priceList.insertBefore(content, unitPrice || template);

    template.remove();

    priceList.dataset.bgEarlyAccessApplied = 'true';
  }

  function initialize(scope) {
    if (!scope || !hasEarlyAccess()) return;

    if (
      scope.matches &&
      scope.matches(PRICE_LIST_SELECTOR)
    ) {
      applyEarlyAccess(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(PRICE_LIST_SELECTOR).forEach(
        applyEarlyAccess
      );
    }
  }

  // Initial page load.
  function start() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Shopify theme editor reload.
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  // Handle dynamically updated product prices.
  const observer = new MutationObserver(function (mutations) {
    if (!hasEarlyAccess()) return;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          initialize(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Handle access changes in another tab.
  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;

    if (hasEarlyAccess()) {
      initialize(document);
    } else {
      window.location.reload();
    }
  });

})();